import { render, staticRenderFns } from "./Input_File.vue?vue&type=template&id=39c0db9a&scoped=true&"
import script from "./Input_File.vue?vue&type=script&lang=js&"
export * from "./Input_File.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39c0db9a",
  null
  
)

export default component.exports